import React from "react";

interface DonationTypeProps {
  [key: string]: any
}

const DonationType: React.FC<DonationTypeProps> = (props:any) => {

  const appeal = (window as any).KEW.collections.appeal[0]

  return (
    <div className="row payment-type">
      { appeal.single_active && appeal.regular_active &&
        <div className="large-12 columns">
          <ul>
            <li
              id="single-gift-tab"
              className={`single ${props.values.payment_type === 'Single' ? 'active' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => {
                props.setFieldValue('payment_type', 'Single')
                props.setFieldValue('amount', appeal.single_pp2)
              }}
              onKeyPress={() => {
                props.setFieldValue('payment_type', 'Single')
                props.setFieldValue('amount', appeal.single_pp2)
              }}>
                <div className="inner">Single gift</div>
            </li>
            <li
              id="monthly-gift-tab"
              className={`regular ${props.values.payment_type === 'Regular' ? 'active' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => {
                props.setFieldValue('payment_type', 'Regular')
                props.setFieldValue('amount', appeal.regular_pp2)
              }}
              onKeyPress={() => {
                props.setFieldValue('payment_type', 'Regular')
                props.setFieldValue('amount', appeal.regular_pp2)
              }}>
                <div className="inner">Monthly gifts</div>
            </li>
          </ul>
        </div>
      }
    </div>
  );
};

export default DonationType;





